import { formatToCurrency } from "src/js/util/currency";
import { Purchase, Transaction } from "../../typings/TransactionsResponse";
import { TransactionPurchaseType } from "@gql/li-api/graphql";

export const formatTransactionURL = (purchase: Purchase) => {
  return purchase && (purchase.title_document ? purchase.title_document.url : purchase?.map_print?.url);
};

export const formatPurchaseAmount = (transaction: Transaction) => {
  const purchase = transaction.purchase;
  if (!purchase) {
    return "N/A";
  }
  let amount = 0;
  if (purchase.map_print) {
    amount = -purchase.amount;
  } else if (purchase.title_document) {
    amount = transaction.amountInPence / 100;
  } else if (purchase.type === TransactionPurchaseType.ThirdPartyOnDemand) {
    amount = -(purchase.amount / 100);
  }

  if (!amount) return "N/A";
  if (amount > 0) return `+${formatToCurrency(amount, "GBP")}`;
  if (amount < 0) return formatToCurrency(amount, "GBP") || "";
  return "N/A";
};
